import { formatMoney } from '../../lib/format'
import { parseAmount } from '../../lib/number'

/**
 * How an MC number is shown to a person.
 *
 * The API stores and returns the canonical digits — that is the form that gets pasted
 * into an FMCSA lookup, and the form two spellings of the same broker collapse into.
 * Everywhere a dispatcher reads it, though, it carries the prefix they see printed on
 * every rate confirmation. One helper so the book and the form can never disagree.
 */
export function formatMcNumber(mcNumber: string | null): string | null {
  return mcNumber === null || mcNumber === '' ? null : `MC-${mcNumber}`
}

/**
 * The bond as money ("$75,000.00") for the field at rest. Text that does not parse is
 * returned untouched — the form's own validation is what gets to complain about it.
 */
export function formatBondAmount(value: string, language: string): string {
  const amount = parseAmount(value)
  return amount === null ? value : formatMoney(amount, 'USD', language)
}
